import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export function ProfileTickLiner24() {
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M14.4405 19.05L15.9605 20.57L19.0005 17.53M11.99 21.81C10.17 21.81 8.36004 21.35 6.98004 20.43C4.56004 18.81 4.56004 16.17 6.98004 14.56C9.73004 12.72 14.24 12.72 16.99 14.56M12.1596 10.87C12.0596 10.86 11.9396 10.86 11.8296 10.87C9.44965 10.79 7.55965 8.84 7.55965 6.44C7.54965 3.99 9.53965 2 11.9896 2C14.4396 2 16.4296 3.99 16.4296 6.44C16.4296 8.84 14.5296 10.79 12.1596 10.87Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}
